export const errorUtils = {
    401: "sesión expirada",
    403: "No tiene autorización para realizar esta operación",
    404: "Página no encontrada" ,
    500: "Error inesperado"
  }